import axios from 'axios';

const publicInfluencerApi = axios.create({
  baseURL: process.env.REACT_APP_APPURLS,
});

const PUBLIC_ENDPOINTS = {
  influencers: 'api/auth/public/influencers/',
  influencerDetail: 'api/auth/public/influencer_detail/',
};

export const resolveInfluencerPayload = (response) => response?.data?.data ?? response?.data ?? {};

export const resolveInfluencerRows = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.results)) return payload.data.results;
  if (payload?.id || payload?.handler_id || payload?.handlerunique_id) return [payload];
  if (payload?.data?.id || payload?.data?.handler_id || payload?.data?.handlerunique_id) {
    return [payload.data];
  }
  return [];
};

export const fetchInfluencers = () => publicInfluencerApi.get(PUBLIC_ENDPOINTS.influencers);

export const fetchInfluencerDetail = (handlerId) =>
  publicInfluencerApi.get(`${PUBLIC_ENDPOINTS.influencerDetail}?handler_id=${handlerId}`);

